// Ionic & Angular Imports
import {Component} from '@angular/core';
import {App, Events, AlertController, NavController, LoadingController, Loading} from 'ionic-angular';
import {Storage} from '@ionic/storage';

// Components
import {BasePage} from '../base.component';
import {HomePage} from '../home/home.component';
import {ReportPage} from '../report/report.component';

// Services
import {rsSessionSvc} from '../../services/auth.service';
import {rsReportSvc} from '../../services/report.service';

@Component({
    templateUrl: 'login.html',
})
export class LoginPage extends BasePage {

    storage: Storage = null; 
    username : string = "Administrator";
    password : string = "pa55w0rd";
    remember_me : boolean = true;

    constructor(
        protected alertCtrl: AlertController,
        private loadingCtrl : LoadingController,
        private navCtrl : NavController,
        private authSvc : rsSessionSvc,
        private reportSvc : rsReportSvc,
        private events : Events,
        private app : App,
        
    ){
        // Construct base class
        super( alertCtrl );

        // Create our storage 

        this.storage = new Storage();
        this.storage.get('remember-me').then( ret => {
            if( ret === true ) {
                this.remember_me = true;

                this.storage.get('app-username').then((user) => {
                    this.username = user;
                });

                this.storage.get('app-password').then((pass) => {
                    this.password = pass;
                });
            }
            else
            {
                this.remember_me = false;
                this.username = undefined;
                this.password = undefined;
            }
        });
    }

    ionViewDidEnter() {
        this.app.setTitle( "HydroconDFR" );
    }

    onToggle(event) {
        this.storage.set('remember-me', event._checked );
    }

    login(event) {
       let  loading : Loading = this.loadingCtrl.create({
            content: 'Authenticating...',
        });
        loading.present();

        this.authSvc.authenticate( this.username, this.password ).subscribe( result => {            
            // Save our username and password
            if( this.remember_me === true ) {
                this.storage.set('app-username', this.username );
                this.storage.set('app-password', this.password );
            } else {
                this.storage.remove('app-username');
                this.storage.remove('app-password');
            }

            this.storage.get("open-recent").then( (ret) => {

                if( ret === true )
                {
                    // Attempt to load the most recent report for the current user
                    this.reportSvc.getRecentReport().subscribe( result => {
                        // Report was updated
                    }, err => {
                        // Navigate to the standard home screen
                        this.navCtrl.setRoot( HomePage, {
                            auth: true
                        }, {
                            animate: true,
                            direction: "forward"
                        }).then( () => {
                            // Dismiss our loading spinner
                            loading.dismiss();
                        });            
                    }, () => {
                        // Navigate to our report page
                        this.navCtrl.push( ReportPage, {}, { 
                            animate: true, direction: 'forward'
                        }).then( () => {                    
                            loading.dismiss();
                        });                 
                    });
                }
                else
                {
                    // Navigate to the standard home screen
                    this.navCtrl.setRoot( HomePage, {
                        auth: true
                    }, {
                        animate: true,
                        direction: "forward"
                    }).then( () => {
                        // Dismiss our loading spinner
                        loading.dismiss();
                    });  
                }
            });
        }, err => {
            // Error handler
            loading.dismiss().then( () => {
                this.displayError("An error has occurred.  Please try again later." );
            });
        }, () => {
            console.log('complete');
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/login/login.component.ts